 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML9780292799325_04_CPY from '@/components/html/9780292799325_04_cpy'
 import HTML9780292799325_03_TIT from '@/components/html/9780292799325_03_tit'
 import HTML9780292799325_01_HA1 from '@/components/html/9780292799325_01_ha1'
 import HTML9780292799325_02_FMT from '@/components/html/9780292799325_02_fmt'
 import HTML9780292799325_05_DED from '@/components/html/9780292799325_05_ded'
 import HTML9780292799325_06_TOC from '@/components/html/9780292799325_06_toc'
 import HTML9780292799325_07_ACK from '@/components/html/9780292799325_07_ack'
 import HTML9780292799325_08_FM2 from '@/components/html/9780292799325_08_fm2'
 import HTML9780292799325_09_HAF1 from '@/components/html/9780292799325_09_haf1'
 import HTML9780292799325_10_IMG from '@/components/html/9780292799325_10_img'
 import HTML9780292799325_11_CH01 from '@/components/html/9780292799325_11_ch01'
 import HTML9780292799325_12_CH02 from '@/components/html/9780292799325_12_ch02'
 import HTML9780292799325_13_CH03 from '@/components/html/9780292799325_13_ch03'
 import HTML9780292799325_14_CH04 from '@/components/html/9780292799325_14_ch04'
 import HTML9780292799325_15_CH05 from '@/components/html/9780292799325_15_ch05'
 import HTML9780292799325_16_CH06 from '@/components/html/9780292799325_16_ch06'
 import HTML9780292799325_17_CH07 from '@/components/html/9780292799325_17_ch07'
 import HTML9780292799325_18_CH08 from '@/components/html/9780292799325_18_ch08'
 import HTML9780292799325_19_CH09 from '@/components/html/9780292799325_19_ch09'
 import HTML9780292799325_20_CH10 from '@/components/html/9780292799325_20_ch10'
 import HTML9780292799325_21_CH11 from '@/components/html/9780292799325_21_ch11'
 import HTML9780292799325_22_CH12 from '@/components/html/9780292799325_22_ch12'
 import HTML9780292799325_23_CH13 from '@/components/html/9780292799325_23_ch13'
 import HTML9780292799325_24_CH14 from '@/components/html/9780292799325_24_ch14'
 import HTML9780292799325_25_CH15 from '@/components/html/9780292799325_25_ch15'
 import HTML9780292799325_26_CH16 from '@/components/html/9780292799325_26_ch16'
 import HTML9780292799325_27_CH17 from '@/components/html/9780292799325_27_ch17'
 import HTML9780292799325_28_CH18 from '@/components/html/9780292799325_28_ch18'
 import HTML9780292799325_29_CH19 from '@/components/html/9780292799325_29_ch19'
 import HTML9780292799325_30_CH20 from '@/components/html/9780292799325_30_ch20'
 import HTML9780292799325_31_CH21 from '@/components/html/9780292799325_31_ch21'
 import HTML9780292799325_32_CH22 from '@/components/html/9780292799325_32_ch22'
 import HTML9780292799325_33_CH23 from '@/components/html/9780292799325_33_ch23'
 import HTML9780292799325_34_CH24 from '@/components/html/9780292799325_34_ch24'
 import HTML9780292799325_35_CH25 from '@/components/html/9780292799325_35_ch25'
 import HTML9780292799325_36_CH26 from '@/components/html/9780292799325_36_ch26'
 import HTML9780292799325_37_CH27 from '@/components/html/9780292799325_37_ch27'
 import HTML9780292799325_38_CH28 from '@/components/html/9780292799325_38_ch28'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML9780292799325_39_EPI from '@/components/html/9780292799325_39_epi'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/9780292799325_06_toc",
 			"name" : "html/9780292799325_06_toc",
 			"component" : HTML9780292799325_06_TOC
 		},
 		{
 			"path" : "/html/9780292799325_07_ack",
 			"name" : "html/9780292799325_07_ack",
 			"component" : HTML9780292799325_07_ACK
 		},
 		{
 			"path" : "/html/9780292799325_08_fm2",
 			"name" : "html/9780292799325_08_fm2",
 			"component" : HTML9780292799325_08_FM2
 		},
 		{
 			"path" : "/html/9780292799325_09_haf1",
 			"name" : "html/9780292799325_09_haf1",
 			"component" : HTML9780292799325_09_HAF1
 		},
 		{
 			"path" : "/html/9780292799325_10_img",
 			"name" : "html/9780292799325_10_img",
 			"component" : HTML9780292799325_10_IMG
 		},
 		{
 			"path" : "/html/9780292799325_11_ch01",
 			"name" : "html/9780292799325_11_ch01",
 			"component" : HTML9780292799325_11_CH01
 		},
 		{
 			"path" : "/html/9780292799325_12_ch02",
 			"name" : "html/9780292799325_12_ch02",
 			"component" : HTML9780292799325_12_CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js